import { faClone, faEraser, faRightFromBracket, faUnlock } from '@fortawesome/pro-regular-svg-icons';

export const BROWSER_MACHINE_OPTIONS = [
  {
    id: 'useKaliLinux',
    value: 'Kali Linux',
    title: 'Use Kali Linux',
    subTitle: 'Web-based Kali Machine',
    type: 'button',
    handleClickSelectedOption: () => {},
  },
  {
    id: 'useAttackBox',
    value: 'AttackBox',
    title: 'Use AttackBox',
    subTitle: 'Recommended',
    type: 'button',
    handleClickSelectedOption: () => {},
  },
];

export const OPTIONS = [
  {
    id: 'cloneRoom',
    value: 'Clone Room',
    title: 'Clone Room',
    type: 'button',
    icon: faClone,
  },
  {
    id: 'resetProgress',
    value: 'Reset Progress',
    title: 'Reset Progress',
    type: 'button',
    icon: faEraser,
  },
  {
    id: 'unlockAllTasks',
    value: 'Unlock All Tasks',
    title: 'Unlock All Tasks',
    type: 'button',
    icon: faUnlock,
  },
  {
    id: 'Leave',
    value: 'Leave',
    title: 'Leave',
    type: 'button',
    icon: faRightFromBracket,
  },
  {
    id: 'leaveAsTeam',
    value: 'Leave as a team',
    title: 'Leave as a team',
    type: 'button',
    icon: faRightFromBracket,
  },
];

export enum OPTIONSDROPDOWN {
  RESET_PROGRESS = 'Reset Progress',
  LEAVE = 'Leave',
  LEAVE_AS_TEAM = 'Leave as a team',
  CLONE_ROOM = 'Clone Room',
  UNLOCK_ALL_TASKS = 'Unlock All Tasks',
}

export enum HELPOPTIONSDROPDOWN {
  VIDEO_SOLUTION = 'Video Solution',
  WRITEUPS = 'Write-ups',
  KNOWLEDGE_BASE = 'Knowledge Base',
  ASK_COMMUNITY = 'Ask Community',
}
